<template>
  <div class="el-container">
    <img v-for="item in solutionList" :id="'nesc_' + item.title" :ref="'nesc_' + item.title" :key="item.id" class="nesc_nd1_li" :src="require('../assets/image/solutions/' + item.title+ (lang === 'en' ? '_EN' : '') +'.jpg')" @load="loadImg" />
  </div>
</template>

<script>
export default {
  name: 'IndustrySolutions',
  data: () => {
    return {
      solutionList: [
        { id: 's1', title: 'shippingIndustrySolution', content: 'shippingIndustrySolution' },
        { id: 's2', title: 'deliveryIndustrySolution', content: 'deliveryIndustrySolution' },
        { id: 's3', title: 'policeIndustrySolution', content: 'policeIndustrySolution' },
        { id: 's4', title: 'parkIndustrySolution', content: 'parkIndustrySolution' }
      ],
      activeSlide: 'shippingIndustrySolution',
      lang: '',
      type: '',
      loadedImgs: 0
    }
  },
  mounted() {
    const lang = window.sessionStorage.getItem('language')
    this.lang = lang
  },
  watch: {
    '$route': {
      handler: 'setDefaultType',
      immediate: true
    },
    'type': {
      handler: 'scrollToPosition'
    }
  },
  methods: {
    loadImg() {
      ++this.loadedImgs
      if (this.loadedImgs === this.solutionList.length) {
        this.scrollToPosition()
      }
    },
    setDefaultType(param) {
      this.type = param.params.type
      console.log(param)
    },
    scrollToPosition() {
      for (const i in this.solutionList) {
        if (this.type === this.solutionList[i].title) {
          const div = document.getElementById('nesc_' + this.type)
          console.log(div)
          console.log(div.offsetTop)
          window.scrollTo({ top: div.offsetTop - 64, behavior: 'smooth' })
          return
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  height: auto !important;
  display: block;
}
.nesc_nd1_li {
  position: relative;
  height: calc(100vh - 64px);
  //@media screen and (min-width: 1024px) {
  //  min-height: 800px;
  //}
  @media (min-aspect-ratio: 1.9/1) {
    height: auto;
  }
  @media (max-aspect-ratio: 1.65/1) {
    height: auto;
  }
  @media screen and (max-width: 992px) {
    height: auto;
  }
}
.nesc_list_png {
  width: 100%;
  height: 100%;
}
</style>
